import { observer } from 'mobx-react';
import { useState } from 'react';
import { MetadataArrowRightIcon, MetadataStatusIcon } from '../../assets/icons';
import { StatusProgressSteps } from '../StatusProgressSteps/StatusProgressSteps';
import { VaultStatusMap } from '../VaultStatuses/VaultStatusMap';
import { SectionWrapper, SectionHeader, SectionHeaderLeft, SectionHeaderRight, SectionIcon, SectionTitle, ArrowIcon, SectionContent } from './MetadataStatusSection.styles';

export const MetadataStatusSection = observer(({ file }) => {
    const [statusOpen, setStatusOpen] = useState(false);

    const isDoneStatus = (status) => {
        return status?.toLowerCase() === 'done';
    };

    const handleStatusToggle = () => {
        if (isDoneStatus(file.status)) {
            return;
        }
        setStatusOpen(!statusOpen);
    };

    return (
        <SectionWrapper noHover={isDoneStatus(file.status)}>
            <SectionHeader clickable={!isDoneStatus(file.status)} isOpen={statusOpen} onClick={handleStatusToggle}>
                <SectionHeaderLeft>
                    <SectionIcon><MetadataStatusIcon /></SectionIcon>
                    <SectionTitle>Status</SectionTitle>
                </SectionHeaderLeft>
                <SectionHeaderRight style={{gap: '0'}}>
                    {VaultStatusMap(file.status)}
                    {!isDoneStatus(file.status) && <ArrowIcon isOpen={statusOpen}><MetadataArrowRightIcon /></ArrowIcon>}
                </SectionHeaderRight>
            </SectionHeader>
            {statusOpen && (
                <SectionContent>
                    <StatusProgressSteps file={file}/>
                </SectionContent>
            )}
        </SectionWrapper>
    );
}); 